export const ONBOARDING_COPY: Record<string, string> = {
  ACTION_SKIP: 'Skip',
  ACTION_PREVIOUS: 'Previous',
  ACTION_NEXT: 'Next',
  ACTION_GET_STARTED: 'Get Started',
};

export function resolveOnboardingCopy(key: string): string {
  return ONBOARDING_COPY[key] ?? key;
}
